import { Backend } from '@shared/datastore/core';
import { SiteStatsResultAjax } from './site-stats.backend-model';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    siteStats: SiteStatsResultAjax;
  }
}

export const siteStatsBackend: Backend<'siteStats'> = {
  fetch: () => ({
    endpoint: `site-stats.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/site-stats/site-stats.backend.ts